<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <router-link class="btn btn-primary" to="/ajouter-contrat">
          <i class="fa fa-plus-circle"></i>
          Ajouter un contrat
        </router-link>
      </div>
      <div class="d-flex align-items-center">
        <form class="search-box position-relative me-15">
          <input type="text" v-model="searchTerm" class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher un contrat" />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25">
    <div class="col-md-12">
      <div class="row">
        <!-- <div class="row d-flex justify-content-center align-items-center text-center"> -->
        <div class="col-md-3">
          <div class="form-group mb-15 mb-sm-20 mb-md-25">
            <label class="d-block text-black fw-semibold mb-10">
              Marché
            </label>
            <Field v-model="_marche" name="marche" v-slot="{ field }">
              <Multiselect v-model="field.value" v-bind="field" :options="marchesOptions" :preserve-search="true"
                :multiple="false" :searchable="true" placeholder="Sélectionner le marché" label="label"
                track-by="label" />
            </Field>
            <ErrorMessage name="marche" class="text-danger" />
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group mb-15 mb-sm-20 mb-md-25">
            <label class="d-block text-black fw-semibold mb-10">
              Type
            </label>
            <Field v-model="_type" name="type" v-slot="{ field }">
              <Multiselect v-model="field.value" v-bind="field" :options="typesOptions" :preserve-search="true"
                :multiple="false" :searchable="true" placeholder="Sélectionner le type" label="label"
                track-by="label" />
            </Field>
            <ErrorMessage name="type" class="text-danger" />
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group mb-15 mb-sm-20 mb-md-25">
            <label class="d-block text-black fw-semibold mb-10">Date de création</label>
            <input type="date" v-model="_dateR" class="form-control" @change="rechercher" />
          </div>
        </div>
      </div>
    </div>
    </div>
    <hr>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Référence
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Mise en application
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Code Place
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Marchand
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Marché
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Type
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Loyer
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Montant contrat
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Date
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Statut
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(contrat, index) in contrats" :key="index">
              <td class="shadow-none lh-1 fw-medium">
                {{ contrat?.reference }}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                {{ format_Date(contrat.dateMiseEnService) }}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                {{ contrat?.place?.code }}
              </td>
              <td class="shadow-none lh-1 fw-medium" v-if="contrat?.usager?.raisonSocial == null">
                {{ contrat?.usager?.nom + " " + contrat?.usager?.prenom }}
              </td>
              <td class="shadow-none lh-1 fw-medium" v-else>
                
                {{ 
                  (contrat?.usager?.sigle) ?
                  " [ " + contrat?.usager?.sigle + " ] " + contrat?.usager?.raisonSocial
                  : contrat?.usager?.raisonSocial 
                }}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                {{ contrat?.place?.marche?.libelle }}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                {{ contrat?.place?.type?.type?.libelle }}
              </td>
              <td class="shadow-none lh-1 fw-medium">{{ contrat.loyer }}</td>
              <td class="shadow-none lh-1 fw-medium">
                {{ contrat?.montantContrat }}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                {{ format_Date(contrat.createdAt) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span :class="getStatutBadge(contrat?.statut).badgeClass">
                  {{ getStatutBadge(contrat.statut).text }}
                </span>
              </td>

              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <div class="dropdown">
                  <button class="btn btn-sm btn-primary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Actions
                  </button>

                  <ul class="dropdown-menu">
                    <li class="dropdown-item d-flex align-items-center">
                      <router-link :to="{
                        name: 'ViewContratPage',
                        params: { id: contrat.id },
                      }">
                        <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>
                        Détails
                        </router-link>
                    </li>
                    <li class="dropdown-item d-flex align-items-center">
                      <router-link :to="{
                        name: 'EditContratPage',
                        params: { id: contrat.id },
                      }">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        Modifier
                      </router-link>
                    </li>

                    <li class="dropdown-item d-flex align-items-center">
                      <a @click="openNewWindow(contrat)" type="button">
                        <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i> Aperçu du contrat
                      </a>
                    </li>

                    <li class="dropdown-item d-flex align-items-center">
                      <a href="javascript:void(0);" @click="regenererEtImprimer(contrat)">
                        <i class="flaticon-printer lh-1 me-8 position-relative top-1"></i>
                        Réimprimer (mis à jour)
                      </a>
                    </li>

                    <li class="dropdown-item d-flex align-items-center"
                      v-if="contrat.statut !== 0">
                      <a href="javascript:void(0);" @click="
                        suppression(contrat.id, contrats, 'contrats', `Contrat ${contrat.id}`)
                        ">
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                        Désactiver
                      </a>
                    </li>

                    <li v-if="contrat.statut !== 2" class="dropdown-item d-flex align-items-center">
                      <a href="javascript:void(0);" data-bs-target="#create-task" data-bs-toggle="modal"
                        @click="openModal(contrat.id)">
                        <i class="flaticon-close lh-1 me-8 position-relative top-1"></i> Resiliation
                      </a>
                    </li>
                    <li v-if="contrat.statut !== 1" class="dropdown-item d-flex align-items-center">
                      <a href="javascript:void(0);"
                        @click="modififContratId(contrat.id)" data-bs-toggle="modal" data-bs-target="#AddContratModal">
                        <i class="flaticon-unlock lh-1 me-8 position-relative top-1"></i>Activer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>


      <div class="modal fade" id="create-task" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">Voulez-vous résilier ce contrat ?</h6>
              <button type="button" id="close-modal" class="btn-close" data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div class="modal-body px-4">
              <Form ref="contratsForm" @submit="addContrats" :validation-schema="contratsSchema">
                <div class="row gy-2">
                  <div class="col-md-4-3">
                    <label class="d-block fw-semibold mb-10">
                      Motif<span class="text-danger"></span>
                    </label>
                    <Field name="motifAnnuler" as="textarea" placeholder="Entrer le motif"
                      class="form-control shadow-none rounded-0 text-black" />
                    <ErrorMessage name="motifAnnuler" class="text-danger" />
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="submit" class="btn btn-primary">Annuler</button>
                  <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                  aria-label="Close">
                    Fermer
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>


      <!-- <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div> -->
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent2 :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
  <EditEtatContrat @get-all-contrat="getAllContrats" :id="contratId" @openmodal="showModalEdite"
    @close="getAllContrats" />
</template>
<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import ApiService from "@/services/ApiService";
import { Contrat } from "@/models/Contrat";
import { format_date, suppression, error, format_Date, success, getUrlApiForFiles } from "@/utils/utils";
import PaginationComponent from "@/components/Utilities/Pagination.vue";
import PaginationComponent2 from "@/components/Utilities/Pagination2.vue";
import JwtService from "@/services/JwtService";
import { Form, Field, ErrorMessage } from "vee-validate";
import Multiselect from "@vueform/multiselect";
import { stringify } from "querystring";
import * as Yup from 'yup';
import EditEtatContrat from "./EditEtatContrat.vue";
import Swal from "sweetalert2";

export default defineComponent({
  name: "ListeContrat",
  components: {
    PaginationComponent2,
    Form,
    Multiselect,
    EditEtatContrat,
    Field,
    ErrorMessage 
  },
  setup() {
    onMounted(() => {
      getAllContrats();
      getAllTypes();
      getAllMarches();
    });
    const contratsSchema = Yup.object().shape({
      motifAnnuler: Yup.string().required("Le motif est obligatoire"),
    });
    const contratsForm = ref(null);
    const contrats = ref<Array<Contrat>>([]);
    const contrat = ref<Contrat>();
    const searchTerm = ref("");
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);  
    const _marche = ref("");
    const _type = ref("");
    const marchesOptions = ref([]);
    const typesOptions = ref([]);
    const _dateR = ref("");
    const contratii = ref();
    const openModal = (id: number) => {
      contratii.value = id;
    };

    
    const contratId = ref();
    const modififContratId = (id: number) => {
      contratId.value = id;
    };
    const getStatutBadge = (statut: number) => {
      switch (statut) {
        case 0:
          return {
            text: "En attente",
            badgeClass: "badge bg-secondary text-white",
          };
        case 1:
          return {
            text: "Actif",
            badgeClass: "badge bg-info text-white",
          };
        case 2:
          return {
            text: "Resilier",
            badgeClass: "badge bg-danger text-white",
          };
        default:
          return {
            text: "",
            badgeClass: "badge bg-white text-danger",
          };
      }
    };


    function triggerButtonClick(buttonId: string) {
      const button = document.getElementById(buttonId) as HTMLButtonElement;
      if (button) {
        button.click(); // Simule un clic
      } else {
        console.error(`Button with ID "${buttonId}" not found.`);
      }
    }

    watch(_type, (newTerm, oldTerm) => {
      if (newTerm !== oldTerm && newTerm !== "") {
        page.value= 1;
        limit.value = 10;
        _type.value = newTerm;
        rechercher();
      }
    });
    
    watch(_marche, (newTerm, oldTerm) => {
      if (newTerm !== oldTerm && newTerm !== "") {
        page.value= 1;
        limit.value = 10;
        _marche.value = newTerm;
        rechercher();
      }
    });
    watch(_dateR, (newTerm, oldTerm) => {
      if (newTerm !== oldTerm && newTerm !== "") {
        _dateR.value = newTerm
        rechercher();
      }
    });
    watch(searchTerm, (newTerm, oldTerm) => {
      if (newTerm !== oldTerm && newTerm !== "") {
        page.value= 1;
        limit.value = 10;
        searchTerm.value = newTerm;
        rechercher();
      }
    });

    const addContrats = async (values, { resetForm }) => {
      values["id"] = contratii.value;
      values["contrat"] = true;
      ApiService.put("/resiliation/contrat/" + values.id, values)
        .then(({ data }) => {
          console.log('depense', data);
          if (data.code === 200) {
            success(data.message);
            resetForm();
            getAllContrats();
            triggerButtonClick("close-modal");
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };



    const getCurrentDate = () => {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const year = today.getFullYear();
      _dateR.value = `${year}-${month}-${day}`;
      return _dateR.value;
    };

    const getAllMarches = async () => {
      try {
        const response = await ApiService.get("/all/marche");
        const marchesData = response.data.data.data;
        console.log("Data", marchesData);
        marchesOptions.value = marchesData.map((marche) => ({
          value: marche.id,
          label: marche.libelle,
        }));
      } catch (error) {
        //error(response.data.message)
      }
    };

    const getAllTypes = async () => {
      try {
        const response = await ApiService.get("/all/type");
        const typesData = response.data.data.data;
        console.log("Data", typesData);
        typesOptions.value = typesData.map((type) => ({
          value: type.id,
          label: type.libelle,
        }));
      } catch (error) {
        //error(response.data.message)
      }
    };

    const handlePaginate = async ({ page_, limit_ }) => {
      try {
        page.value = page_;
        limit.value = limit_;
        console.log(limit.value, page.value);
        await getAllContrats(page_, limit_, searchTerm.value, _marche.value, _type.value, _dateR.value);
      } catch (error) {
        //
      }
    };
    function rechercher() {
      getAllContrats();
    }
    const getAllContrats = (pagee = 1, limitt = 10, searchTermm = "", marche = "", type = "", dateR = "") => {
      const donne = {
        page: (pagee) ? pagee : page.value,
        limit: (limitt) ? limitt : limit.value,
        searchTerm: (searchTermm) ? searchTermm : searchTerm.value,
        marche: (marche) ? marche : _marche.value,
        type: (type) ? type : _type.value,
        dateR: (dateR) ? dateR : _dateR.value
      };
      return ApiService.post(`all/contrats`, donne)
        .then(({ data }) => {
          contrats.value = data.data.data;
          console.log("contratss", contrats.value);
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }
    const privileges = ref<Array<string>>(JwtService.getPrivilege());
    const checkPermission = (name) => {
      return privileges.value.includes(name);
    };

    const openAndPrint = (url: string) => {
      const newWindow = window.open(url, "_blank");
      if (newWindow) {
        newWindow.onload = () => {
          newWindow.print();
        };
      } else {
        console.error("Impossible d'ouvrir la fenêtre");
      }
    };

    function openNewWindow(data: any, dossier = "Contrat") {
      openAndPrint(getUrlApiForFiles(dossier, data.reference + ".pdf"));
    }

    // Dans ListeContrat.vue → remplace toute ta fonction regenererEtImprimer
const regenererEtImprimer = async (contrat: any) => {
  try {
    // je voudrais utiliser  Swal.fire pour afficher un message de chargement pendant la régénération du PDF, mais comme c'est une fonction asynchrone, je vais faire simple pour l'instant
    Swal.fire({
      title: "Régénération du Contrat",
      text: "Veuillez patienter pendant que le document est régénéré...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    // 1. Régénère le PDF à jour
    await ApiService.post(`/contrats/${contrat.id}/regenerer-pdf`, contrat);

    // 2. URL avec anti-cache
    const pdfUrl = getUrlApiForFiles("Contrat", contrat.reference + ".pdf") + `?t=${Date.now()}`;

    // 3. IFRAME INVISIBLE → 0 erreur cross-origin, impression automatique
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';_type
    iframe.src = pdfUrl;

    iframe.onload = () => {
      setTimeout(() => {
        try {
          iframe.contentWindow?.focus();
          iframe.contentWindow?.print();
        } catch (e) {
          console.warn("Impression bloquée, ouverture classique");
          window.open(pdfUrl, '_blank');
        }
        // Nettoyage
        setTimeout(() => document.body.removeChild(iframe), 3000);
      }, 800);
    };

    document.body.appendChild(iframe);
    Swal.close();

  } catch (err) {
    error("Erreur lors de la régénération du PDF");
  }
};
    return {
      contrats,
      format_Date,
      checkPermission,
      format_date,
      suppression,
      contrat,
      page,
      totalPages,
      limit,
      contratsSchema,
      modififContratId,
      totalElements,
      handlePaginate,
      searchTerm,
      rechercher,
      openNewWindow,
      marchesOptions,
      typesOptions,
      _marche,
      _type,
      _dateR,
      contratId,
      getCurrentDate,
      regenererEtImprimer,
      openModal,
      addContrats,
      getAllContrats,
      getStatutBadge
    };
  },
});
</script>
<style scoped>
  .dropdown-menu a,
  .dropdown-menu .router-link-active {
    text-decoration: none !important;
  }
</style>